import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPost, addPostSub, addPostId,addPostDay,addCount } from "../store";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Write() {

  let getLogin = sessionStorage.getItem('login')

  let navigate = useNavigate();
  let dispatch = useDispatch()
  let rStore = useSelector((state)=>{return state})
  const [nowIdLength, setIdLength] = useState(rStore.postId.length)

     // 포스트 쓰기

     function writePost() {

        if(getLogin){
          dispatch(addPostSub(inputPostName)) 
          dispatch(addPost(inputPost))
          setIdLength(nowIdLength+1)
          dispatch(addPostId(inputPostName+nowIdLength))
          dispatch(addPostDay(nowDay))
          dispatch(addCount(rStore.countPost.length+1))

          let writed = localStorage.getItem('writed')
          writed = JSON.parse(writed)
          writed.unshift([
            rStore.countPost.length+1,inputPostName,inputPost,nowDay
          ])
          localStorage.setItem('writed',JSON.stringify(writed))

          // localStorage.setItem('postList',JSON.stringify({
          //   'postId':inputPostName+nowIdLength,
          //   'postSub':inputPostName,
          //   'post':inputPost,
          //   'postDay':nowDay
          
          // }))

        }
        else{
   
        dispatch(addPostSub(inputPostName)) 
        dispatch(addPost(inputPost))
        setIdLength(nowIdLength+1)
        dispatch(addPostId(inputPostName+nowIdLength))
        dispatch(addPostDay(nowDay))
        dispatch(addCount(rStore.countPost.length+1))
      }
      
       
     }

  const [inputPostName, setInputPostName] = useState('')
  const [inputPost, setInputPost] = useState('') 
  
  let date = new Date();
  let year = date.getFullYear();
  let month = ("0" + (1 + date.getMonth())).slice(-2);
  let day = ("0" + date.getDate()).slice(-2);
  let hours = date.getHours(); // 시
  let minutes = date.getMinutes();  // 분
  let seconds = date.getSeconds();  // 초
  
  let nowDay = year + "-" + month + "-" + day + "  " + hours + '시 ' + minutes + '분 ' + seconds + '초'

    return(
          <div>
            <div>
              <input className="포스트 제목" style={{width:"100%",height:"40px"}}
              onChange={(e)=>{
                setInputPostName(e.target.value)
              }}
              ></input>
             <input className="글 내용" style={{width:"100%", height:"130px"}}
             onChange={(e)=>{
              setInputPost(e.target.value)
            }}></input>
            </div>
            <Button style={{float:'right', marginTop:'10px'}}
            variant="dark" onClick={()=>{
                if(inputPostName === '') {
                  alert('포스트 제목이 입력되지 않았습니다')
                } else if (inputPost === '') {
                  alert('포스트 내용이 입력되지 않았습니다.')
                } else {        
              writePost()  
              console.log(nowDay)
              navigate('/')                   
              }}}>제출</Button>
        </div>
    )
}

export default Write
      